import { CART_RECEIVE } from '../constants';

export const cart = (state = { quantity: 0, orderTotal: 0 }, action) => {
  switch (action.type) {
    case CART_RECEIVE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
